var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimapAncestorBetweenAncestorsNotBetweenDescendents = function SvgMinimapAncestorBetweenAncestorsNotBetweenDescendents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6B7280",
    strokeWidth: 2,
    d: "M11 0v24M4 12h7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 3,
    fill: "#1F2937"
  })));
};
export default SvgMinimapAncestorBetweenAncestorsNotBetweenDescendents;